import { Stack, Typography, useTheme } from "@mui/material";
import { useAxesTooltip } from "@mui/x-charts";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const width = 180;
const padding = 16;

type Props = { pos: { x: number; y: number } };

export const DataLineChartTooltip: FC<Props> = ({ pos }) => {
	const { t } = useResource();
	const theme = useTheme();
	const tooltip = useAxesTooltip();

	if (!tooltip?.[0]) return null;

	const data = tooltip[0];
	const top = pos.y - 100;
	let left = pos.x - width / 2;

	if (left < padding) {
		left = padding;
	}

	if (left > window.innerWidth - (width + padding)) {
		left = window.innerWidth - (width + padding);
	}

	return (
		<Stack
			position={"absolute"}
			left={left}
			top={top}
			padding={"4px 8px"}
			borderRadius={0.4}
			width={width}
			sx={{ backgroundColor: theme.palette.grey[50] }}
		>
			<Stack direction={"row"} justifyContent={"space-between"}>
				<Typography
					fontSize={12}
					fontWeight={400}
					color={theme.palette.grey[500]}
				>
					{t(Resources.Portfolio.Chart.Date)}
				</Typography>
				<Typography
					fontSize={12}
					fontWeight={500}
					color={theme.palette.grey[700]}
				>
					{data.axisFormattedValue}
				</Typography>
			</Stack>
			{data.seriesItems
				.filter((item) => {
					const rawValue = item.value;
					return rawValue !== null && rawValue !== undefined && rawValue !== 0;
				})
				.map(({ formattedLabel, formattedValue }) => (
					<Stack
						key={formattedLabel}
						direction={"row"}
						justifyContent={"space-between"}
					>
						<Typography
							fontSize={12}
							fontWeight={400}
							color={theme.palette.grey[500]}
						>
							{formattedLabel}
						</Typography>
						<Typography
							fontSize={12}
							fontWeight={500}
							color={theme.palette.grey[700]}
						>
							{formattedValue}
						</Typography>
					</Stack>
				))}
		</Stack>
	);
};
